import { Icon } from '@components/icons';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import { routes } from '@const/routes';
import styles from './DefaultFallback.module.scss';

export interface IErrorFallbackProps {
    error: Error;
}

// Universal, brand-neutral fallback for the app-root ErrorBoundary (see
// src/app.tsx) — it can render for a crash ANYWHERE in the app (auth pages,
// wallet pages, or the dev portal), so unlike DevErrorFallback it never
// assumes the dev-portal's black-gold tokens (--dp-*) are in scope. "Back to
// dashboard" uses a hard navigation (window.location.assign), not
// react-router's useNavigate — this boundary can catch a crash in the router
// itself, so it must not depend on router context being alive.
const DefaultFallback = (_props: IErrorFallbackProps) => (
    <div className={styles.wrapper} role="alert">
        <span className={styles.icon}>
            <Icon name="error_outlined" width={32} height={32} />
        </span>
        <Typography variant="h4" weight="semibold" className={styles.title}>
            Something went wrong
        </Typography>
        <Typography variant="body3" className={styles.description}>
            We hit an unexpected error loading this page. Try reloading — if it keeps
            happening, please contact support.
        </Typography>
        <div className={styles.actions}>
            <Button
                className={styles.button}
                variant="outlined-primary"
                onClick={() => window.location.assign(routes.dashboard)}>
                Back to dashboard
            </Button>
            <Button
                className={styles.button}
                variant="primary"
                onClick={() => window.location.reload()}>
                Reload page
            </Button>
        </div>
    </div>
);

export default DefaultFallback;
